export default {
  lxSearchCTAText() {
    return "Search";
  },
  lxSearchModalAllyTitle() {
    return "Search this site";
  },
  lxSearchModalAllyCTALabel() {
    return "Search for:";
  },
  lxSearchModalInputplaceholder() {
    return "Type keywords here…";
  },
  lxSearchModalBodyTitle() {
    return "Search by Tags";
  },
  lxSearchResultPageTitle(params: { search: string }) {
    return `You searched for "${params.search}"`;
  },
  lxNoSearchResultPageTitle() {
    return `We didn’t find a match for that search.`;
  },
  lxNoSearchResultPageSubTitle() {
    return `Try again, or head back to <a href="/the-buzz">The Buzz</a>. You can also browse the categories to find articles.`;
  },
};
